export enum LocalStorage {
    accessToken = 'access_token',
    refreshToken = 'refresh_token',
    loginData = 'loginData',
    loginDatas = 'loginDatas',
    applicationMenuId = "applicationMenuId",
    applicationSubMenuId = "applicationSubMenuId",
    routerPath = "routerPath",
    dbName = "dbName"
}